function ConnectedThemesSlider(el) {
    this.el = el;

    const slider = new Flickity(this.el, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true
    });

    // Check if the slider has controls
    const controlWrapperEl = this.el.parentElement.querySelector('.jsSliderControls');
    if (controlWrapperEl) {
        controlWrapperEl.addEventListener('click', e => {
            e.preventDefault();

            if (e.target.classList.contains('prev')) slider.previous();
            else if (e.target.classList.contains('next')) slider.next();
        });
    }
}

(function() {
    const sliderEls = document.querySelectorAll('.jsConnectedThemeSlider');
    for (let i = 0; i < sliderEls.length; i++) new ConnectedThemesSlider(sliderEls[i]);
})();
